import { apiFetch, HTTPMethod } from '../fetch';
import { CalculationInput, CalculationResult } from './interfaces';

export const putCalculationDemo = (companyId: string, calculation: CalculationInput): Promise<CalculationResult> =>
  apiFetch<CalculationResult>(`/companies/${companyId}/calculations/demo`, calculation, HTTPMethod.PUT);

export const putCalculation = (calculation: CalculationInput): Promise<CalculationResult> =>
  apiFetch<CalculationResult>('/companies/calculations/prod', calculation, HTTPMethod.PUT);
